import { render, staticRenderFns } from "./skuaAwaitImport.vue?vue&type=template&id=0bdc3224&scoped=true&"
import script from "./skuaAwaitImport.vue?vue&type=script&lang=js&"
export * from "./skuaAwaitImport.vue?vue&type=script&lang=js&"
import style0 from "./skuaAwaitImport.vue?vue&type=style&index=0&id=0bdc3224&prod&lang=less&scoped=true&"
import style1 from "./skuaAwaitImport.vue?vue&type=style&index=1&id=0bdc3224&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc3224",
  null
  
)

export default component.exports